import { yandexMetrikaReachGoal } from "./yandexMetrika";

/** Идентификаторы целей в Яндекс.Метрике (совпадают с настройками счётчика). */
export const METRIKA_GOALS = {
  TRY_CLICK: "try_click",
  REGISTRATION_SUCCESS: "registration_success",
  ACTIVATION_COMPLETE: "activation_complete",
  PAYMENT_SUCCESS: "payment_success",
};

const ACTIVATION_STORAGE_PREFIX = "bs_ym_activation_";
const PAYMENT_SESSION_KEY = "bs_ym_payment_success";

export function trackTryClick() {
  yandexMetrikaReachGoal(METRIKA_GOALS.TRY_CLICK);
}

export function trackRegistrationSuccess() {
  yandexMetrikaReachGoal(METRIKA_GOALS.REGISTRATION_SUCCESS);
}

/**
 * Активация: онбординг, группа, клиент, настройки и т.п.
 * Шлётся один раз на tenant (localStorage), чтобы не дублировать цель.
 */
export function trackActivationComplete(reason, tenantId) {
  if (typeof window === "undefined") return false;
  const key = `${ACTIVATION_STORAGE_PREFIX}${tenantId || "global"}`;
  try {
    if (localStorage.getItem(key)) return false;
    localStorage.setItem(
      key,
      JSON.stringify({
        reason: reason || "unknown",
        at: new Date().toISOString(),
      }),
    );
  } catch {
    /* still fire goal if storage blocked */
  }
  yandexMetrikaReachGoal(METRIKA_GOALS.ACTIVATION_COMPLETE, {
    reason: reason || "unknown",
  });
  return true;
}

/**
 * Оплата тарифа (возврат с эквайринга).
 * Дублирует сигнал для Метрики; офлайн-конверсия уходит с бэкенда по webhook.
 */
export function trackPaymentSuccess(params) {
  if (typeof window === "undefined") return false;
  try {
    if (sessionStorage.getItem(PAYMENT_SESSION_KEY) === "1") return false;
    sessionStorage.setItem(PAYMENT_SESSION_KEY, "1");
  } catch {
    /* ignore */
  }
  yandexMetrikaReachGoal(METRIKA_GOALS.PAYMENT_SUCCESS, params);
  return true;
}
